<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h4 class="edit-heading mt-3">{{ $t("editProfile") }}</h4>
      </v-col>
    </v-row>
    <v-card class="mb-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12" class="text-center">
                <div class="profile-img-upload">
                  <div class="preview-box">
                    <img
                      :src="
                        uploadedImageUrl ? uploadedImageUrl : '/img/profile.png'
                      "
                      alt="Profile Image"
                    />
                  </div>
                  <input
                    ref="fileUpload"
                    type="file"
                    style="display: none"
                    @change="imageSelection"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  class="mr-2 edit-btn set-img"
                  @click="$refs.fileUpload.click()"
                >
                  <img src="/img/edit.png" class="upload-icon" alt />
                  <p>{{ $t("change") }}</p>
                </v-btn>
                <v-btn
                  v-if="uploadedImageUrl"
                  class="ml-2 delete-btn set-img"
                  @click="removeProfileImage"
                >
                  <img src="/img/delete.png" class="upload-icon" alt />
                  <p>{{ $t("remove") }}</p>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="first"
                  :label="$t('firstName')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="last"
                  :label="$t('lastName')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="email"
                  :label="$t('email')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="phone"
                  :label="$t('phone')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="(field, index) in customerInfo"
                :key="index"
                :cols="12"
                :md="6"
                :order="index % 2"
              >
                <v-text-field
                  v-if="field.fieldName !== 'Enable'"
                  :type="field.dataType"
                  :label="field.fieldName"
                  v-model="field.value"
                ></v-text-field>
                <toggle-button
                  class="toggoleProfile"
                  v-else
                  :value="true"
                  v-model="field.value"
                  :labels="{
                    checked: 'Enable',
                    unchecked: 'Disable',
                  }"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="text-center">
                <button
                  class="btn btn-outline-primary mr-3 pr-3 pl-3"
                  @click="$router.push('/profile')"
                >
                  {{ $t("viewAddress.cancel") }}
                </button>
                <button
                  @click="updateProfile"
                  class="btn btn-primary editSaveBtn ml-3 pr-4 pl-4"
                >
                  {{ $t("viewAddress.save") }}
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "edit-profile",
  components: { ToggleButton },
  data() {
    return {
      first: "",
      removed: "",
      last: "",
      email: "",
      phone: "",
      selected: null,
      options: [
        { text: "Select Your Gender", value: null, disabled: true },
        { text: "Male", value: "Male" },
        { text: "Female", value: "Female" },
      ],
      customerInfo: [],
      uploadedImageUrl: "",
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo,
      defaultAddress: (state) => state.address.defaultAddress,
      userData: (state) => state.profile.userData,
      editData: (state) => state.profile.editData,
    }),
  },
  methods: {
    async imageSelection(event) {
      if (!event.target?.files?.length) return;
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = async (e) => {
        let res = await this.$store.dispatch(
          "profile/uploadLogo",
          e.target.result,
        );
        this.uploadedImageUrl = res.data?.data?.fileUrl || "";
      };
    },
    async updateProfile() {
      let defalutSecurityQuestions = {
        question: "What is your first school",
        answer: "fastforgeAI",
      };
      let newObj = {};
      this.customerInfo.forEach((el) => (newObj[el.fieldName] = el.value));
      let payload = {
        name: { first: this.first, last: this.last },
        extendedAttributes: {
          ...newObj,
          profilePhoto: this.uploadedImageUrl || "none",
          gender: this.selected,
        },
        userName: this.userInfo?.authentication?.userName || "",
        email: this.email,
        phone: this.phone,
        securityQuestions:
          this.userInfo?.authentication?.securityQuestions ||
          defalutSecurityQuestions,
      };

      try {
        let result = await this.$store.dispatch(
          "profile/updateProfileAction",
          payload,
        );

        localStorage.setItem(
          `${process.env.VUE_APP_TENANT}:userInfo`,
          JSON.stringify(result.data.response),
        );
        this.$store.dispatch("auth/setUserData", result.data.response);
        await this.$store.dispatch(
          "profile/getCustomerData",
          this.userInfo._id,
        );
        await this.$store.dispatch("profile/getExternalInfoCustomer", {});
        this.$swal({
          text: this.$t("swal.profileUpdated"),
          type: "success",
          title: this.$t("wishlistProduct.successTitle"),
          timer: 1100,
        });
        this.$router.push("/profile");
      } catch (error) {
        this.$swal({
          text: error.response.data.message || "Something went wrong",
          type: "error",
          // title: this.$t("wishlistProduct.successTitle"),
          timer: 1100,
        });
      }
    },
    removeProfileImage() {
      this.$bvModal
        .msgBoxConfirm("Do you want to remove this image?", {
          title: "Please Confirm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then(() => {
          this.uploadedImageUrl = "";
        });
    },
    isNotAccepted(str) {
      if (!str) return false;
      // Regex for a 40-character hexadecimal string (SHA-1 hash-like)
      const hexPattern = /^[0-9a-fA-F]{40}$/;
      return !hexPattern.test(str); // Return true if string is NOT a 40-char hex
    },
  },
  async mounted() {
    // await this.$store.dispatch("profile/getCustomerData", this.userInfo._id);
    await this.$store.dispatch("profile/getExternalInfoCustomer", {});
    this.first = this.userInfo?.name?.first || "";
    this.last = this.userInfo?.name?.last || "";
    this.email = this.userInfo?.authentication?.email || "";
    this.phone = this.isNotAccepted(this.userInfo?.authentication?.phone || "")
      ? this.userInfo?.authentication?.phone
      : "";
    this.selected = this.userInfo?.extendedAttributes?.gender || "";
    this.uploadedImageUrl =
      this.userData?.extendedAttributes?.profilePhoto || "";
    this.customerInfo = [];
    if (
      this.editData?.externalInfoCustomer &&
      Array.isArray(this.editData.externalInfoCustomer) &&
      this.editData.externalInfoCustomer.length
    ) {
      for (const temp of this.editData.externalInfoCustomer) {
        if (temp.isRequired && this.userData.extendedAttributes) {
          temp.value = this.userData.extendedAttributes[temp.fieldName];
          this.customerInfo.push({
            ...temp,
          });
        }
      }
    }
  },
};
</script>

<style scoped>
.btn-primary {
  color: var(--secondarycolor);
  background-color: var(--secondarycolor);
  border-color: var(--secondarycolor);
  padding: 0.375rem 3.5rem;
}
.edit-heading {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
}
.btn-primary:hover {
  cursor: pointer;
  background-color: var(--primarycolor);
  color: #f2f6fc;
  font-weight: bold !important;
}
.v-text-field {
  padding-top: 12px;
  margin-top: 4px;
  margin-right: 20px;
}
.card-body.text-center {
  box-sizing: border-box;
  position: absolute;
  background: #f8f8f8;
  border-radius: 14px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
input[type="date"] {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
}
.btn-outline-primary:hover {
  background-color: var(--primarycolor);
  color: white;
  border-color: var(--primarycolor);
  font-weight: bold !important;
}
.img {
  border: 3px solid #1c1917;
}
body {
  margin-top: 20px;
  background-color: #f2f6fc;
  color: #69707a;
}
.img-account-profile {
  height: 10rem;
}
.rounded-circle {
  border-radius: 50% !important;
}
.card {
  border-radius: 14px;
}
.card .card-header {
  font-weight: 500;
}
.card-header:first-child {
  border-radius: 0.35rem 0.35rem 0 0;
}
.card-header {
  padding: 1rem 1.35rem;
  margin-bottom: 0;
  background-color: rgba(33, 40, 50, 0.03);
  border-bottom: 1px solid rgba(33, 40, 50, 0.125);
}
.editSaveBtn {
  background: var(--primarycolor);
}
.form-control,
.dataTable-input {
  display: block;
  width: 100%;
  padding: 0.875rem 1.125rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  color: #69707a;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #c5ccd6;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.35rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.nav-borders .nav-link.active {
  color: #0061f2;
  border-bottom-color: #0061f2;
}
.nav-borders .nav-link {
  color: #69707a;
  border-bottom-width: 0.125rem;
  border-bottom-style: solid;
  border-bottom-color: transparent;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0;
  padding-right: 0;
  margin-left: 1rem;
  margin-right: 1rem;
}
#modal-profile h3 {
  color: #0e8225;
}
::v-deep #modal-profile .mdi-menu-down {
  border: none;
  box-shadow: none;
  background-color: #fff !important;
}
::v-deep #modal-profile .custom-select {
  border: none;
  border-bottom: 1px solid #717171;
  border-radius: 0px;
}
.profile-img-upload {
  position: relative;
}
.edit-img-box {
  height: 480px;
  width: 480px;
}
.profile-img-upload .upload-icon {
  z-index: 1;
  position: absolute;
  top: 0;
  margin-left: 15px;
  cursor: pointer;
}
.preview-box img {
  height: 110px;
  width: 110px;
  border-radius: 55px;
  margin: auto;
  object-fit: cover;
}
.set-img {
  width: 100px;
  padding: 3px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.set-img p {
  display: inline-block;
  margin-bottom: 0px;
  margin-left: 6px;
  font-size: 14px;
  font-weight: 600;
}
.edit-btn {
  border: 2px solid #272727;
}
.delete-btn {
  border: 2px solid #ff3c3c;
  color: #ff3c3c;
}
.profile-maindv {
  background: #f8f8f8;
  padding: 15px;
  border-radius: 15px;
  border: 1px solid #efefef;
  width: 100%;
}
.margin-left {
  margin-left: 150px;
}
.edit-icon svg {
  margin-right: 7px;
  margin-top: 4px;
}
.toggoleProfile {
  margin: 20px 0;
}
::v-deep.toggoleProfile.vue-js-switch.toggled .v-switch-button {
  transform: translate3d(60px, 3px, 0px) !important;
  margin-top: 2px;
  z-index: 0;
}
::v-deep.toggoleProfile.vue-js-switch .v-switch-core {
  width: 80px !important;
  height: 26px !important;
}
::v-deep.toggoleProfile.vue-js-switch .v-switch-label {
  font-size: 13px !important;
  margin-top: 2px;
}
::v-deep label[for="input-85"] {
  transform: translateY(-18px) scale(0.75) !important;
}
</style>
